<template>
 <div>
     <el-form-item style="text-align:center" label="经营业务:" prop="totalLength" class="is-required yewuBox" label-width="140px">
       <el-tag
          v-for="item in businessNameList"
          :key="item"
          type="item.type">
           <el-tooltip class="item" effect="dark" :content="item" placement="top-start">
            <span>{{ item }}</span>
          </el-tooltip>
        </el-tag>
        <el-button type="primary" class="yewuBtn" @click="xuanzeFn()">选择业务</el-button>
    </el-form-item>
    <el-dialog  title="选择业务" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"  @close="closeDialog"
     :visible.sync="yewuMark" width="400px" center>
      <span>
         <el-tree
                :data="yewuTree"
                :props="defaultProps"
                show-checkbox
                ref="tree"
                node-key="id"
                :default-expand-all="true"
                :highlight-current="true"
                :expand-on-click-node="false"
                @node-click="handleNodeClick"
            >
          </el-tree>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="yewuMark = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { businessTree } from '@/api/newCrm'
export default {
  name: 'business',
  props: {
    addFrom: {
      type: Object,
      default: function () {
        return {}
      }
    },
    openObjs: {// 后来作为flag用，1、查询全部业务（平台添加、平台开通、属性）2、租户添加客户，3、租户开通客户
      type: Number,
      default: null
    },
    tishiFlag: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      yewuTree: [],
      yewuMark: false,
      businessNameList: [],
      defaultProps: {
        label: 'name',
        children: 'children'
      }
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.addFrom.businessIdList = []
    if (this.addFrom.businessIds) {
      this.businessNameList = this.addFrom.businessName.split(',')
      let arr = this.addFrom.businessIds.split(',')
      arr.forEach(item => {
        this.addFrom.businessIdList.push(Number(item))
      })
    }
  },
  methods: {
    // 点击字体选择取消
    handleNodeClick (data, index) {
      let checkedArr = this.$refs.tree.getCheckedNodes(false, true)
      const n = checkedArr.findIndex(d => d.id === data.id)
      if (n > -1) {
        this.$refs.tree.setChecked(data, false, true)
      } else {
        this.$refs.tree.setChecked(data, true, true)
      }
    },
    xuanzeFn () {
      if (this.tishiFlag) {
        this.$confirm('更改客户经营业务可能会影响其个性化配置，请谨慎操作，是否继续？?', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.yewuMark = true
          businessTree({
            flag: this.openObjs,
            tenantCode: this.openObjs != 1 ? this.addFrom.tenantCode : '',
            relId: this.openObjs == 3 ? this.addFrom.relId : ''
          }).then(res => {
            this.yewuTree = res
            this.$nextTick(function () {
              this.$refs.tree.setCheckedKeys(this.addFrom.businessIdList)
            })
          })
        }).catch(() => {

        })
      } else {
        this.yewuMark = true
        businessTree({
          flag: this.openObjs,
          tenantCode: this.openObjs != 1 ? this.addFrom.tenantCode : '',
          relId: this.openObjs == 3 ? this.addFrom.relId : ''
        }).then(res => {
          this.yewuTree = res
          this.$nextTick(function () {
            this.$refs.tree.setCheckedKeys(this.addFrom.businessIdList)
          })
        })
      }
    },
    saveFn () {
      let ids = this.$refs.tree.getCheckedKeys(true)
      if (ids.length == 0) {
        this.$alert('请选择业务类型', '系统提示')
        return
      }
      this.addFrom.businessIdList = ids
      this.businessNameList = []
      this.$refs.tree.getCheckedNodes(true, false).forEach(item => {
        this.businessNameList.push(item.name)
      })
      this.yewuMark = false
    },
    closeDialog () {

    }
  },
  watch: {
    addFrom: {
      handler (newName, oldName) {
      },
      deep: true
      // immediate: true
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.yewuBox{
  display: flex;
 /deep/ .el-form-item__content{
    display: flex;
    flex-wrap: wrap;
  }
}
/deep/.yewuBtn{
  background-color: #fff;
  padding: 7px 30px;
  color: #0e6eec;
  margin-bottom: 16px;
}
/deep/.el-form-item__content {
    width: 521px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}
// /deep/.el-tag{
//   margin-right:20px;
//   margin-bottom: 16px;
// }
/deep/.el-tag{
  margin-right:15px;
  margin-bottom: 15px;
  display: inline-block;
  width: 22%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
 .el-tag__close{
    position: absolute;
    right: 2px;
    top: 8px;
  }
}
/deep/.el-checkbox__inner{
      width: 18px;
    height: 18px;
    margin-right: 10px;
}
/deep/.el-checkbox__inner::after{
    height: 9px;
    left: 6px;
    top: 1px;
}
</style>
